<script lang="ts" setup>
  import Status from '@/common/shared/Status.vue';
  import store from '@/common/store';
  import { computed } from 'vue';
  import TooltipWrapper from '@/common/shared/TooltipWrapper.vue';

  const props = defineProps<{
    notificationId: string
  }>();

  const data = computed(() => {
    const notification = store.getters['notifications/getItemById'](props.notificationId);
    return notification?.inProgressItems || [];
  });
</script>

<template>
<el-table data-component-name="deleting-items-table"
  :data="data"
  rowKey="id"
>
  <el-table-column data-component-name="el-table-column"
    sortable
    :label="$t('Name')"
    prop="name"
  >
    <template #default="{ row }">
      <tooltip-wrapper data-component-name="tooltip-wrapper"
        :tooltip-text="row.name"
      >
        <el-icon data-component-name="el-icon"
          v-if="row.icon"
          class="mr-16"
          color="brand-primary"
          size="24"
          :name="row.icon"
        /><span>{{ row.name }}</span>
      </tooltip-wrapper>
    </template>
  </el-table-column>
  <el-table-column data-component-name="el-table-column"
    sortable
    :label="$t('Status')"
    prop="statusText"
  >
    <template #default="{ row }">
      <status :status="row.statusIcon">
        {{ row.statusText }}
      </status>
    </template>
  </el-table-column>
</el-table>
</template>
